export enum TransactionCategory {
  DEBIT = "debit",
  CREDIT = "credit",
}
